import { render } from "./IntestineSpecificSectionDetailsEMROATS.vue?vue&type=template&id=61789b13&scoped=true"
import script from "./IntestineSpecificSectionDetailsEMROATS.vue?vue&type=script&lang=js"
export * from "./IntestineSpecificSectionDetailsEMROATS.vue?vue&type=script&lang=js"

import "./IntestineSpecificSectionDetailsEMROATS.vue?vue&type=style&index=0&id=61789b13&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61789b13"],['__file',"src/components/IntestineSpecificSectionDetailsEMROATS.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61789b13"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61789b13', __exports__)) {
    api.reload('61789b13', __exports__)
  }
  
  module.hot.accept("./IntestineSpecificSectionDetailsEMROATS.vue?vue&type=template&id=61789b13&scoped=true", () => {
    api.rerender('61789b13', render)
  })

}


export default __exports__